<template>
  <component :is="`cellsdate`" :col="col" :entry="entry" :key="`td-${col}`" :edit-name="editName"></component>
</template>

<script>
import cellsdate from './Date';

export default {
  components: {
    cellsdate,
  },
  props: {
    entry: Object,
    col: String,
    editName: String,
    flags: Array,
  },
  methods: {},
};
</script>
